import { Suspense } from 'react';
import { Skeleton } from '@sara/ui/components/skeleton';
import { QueryErrorBoundary } from '@sara/ui/components/query-error-boundary';
import { CreateInterviewTypeVersionFormContainerContent } from './CreateInterviewTypeVersionFormContainerContent';
import type { CreateInterviewTypeVersionFormContainerProps } from './types';

export type { CreateInterviewTypeVersionFormContainerProps };

function CreateInterviewTypeVersionFormSkeleton() {
  return (
    <div className="space-y-5">
      <Skeleton className="h-32 rounded-lg" />
      <Skeleton className="h-72 rounded-lg" />
      <Skeleton className="h-72 rounded-lg" />
    </div>
  );
}

export function CreateInterviewTypeVersionFormContainer(
  props: CreateInterviewTypeVersionFormContainerProps
) {
  return (
    <QueryErrorBoundary>
      <Suspense fallback={<CreateInterviewTypeVersionFormSkeleton />}>
        <CreateInterviewTypeVersionFormContainerContent {...props} />
      </Suspense>
    </QueryErrorBoundary>
  );
}
